var ticket = require('../ticket/ticket.js');
let translation = window['langArr'][window['language']];  
/**
 * @description For Video part
 */
var amblems = {
    // england
    LEI : 'Fake_Leicester.png',
    BOU : 'Fake_Bournmouth.png',
    HDD : 'Fake_Huddersfield.png',
    WHU : 'Fake_WestHamUtd.png',
    SWA : 'Fake_SwanCity.png',
    WAT : 'Fake_Watford.png',
    BRH : 'Fake_BrightHoveAlbion.png',
    BUR : 'Fake_Burnley.png',
    WBA : 'Fake_Broomwich.png',
    CHE : 'Fake_Chelsea.png',
    NEW : 'Fake_NewCastle.png',
    MUN : 'Fake_Manchester.png',
    SOU : 'Fake_Southampton.png',
    TOT : 'Fake_TottenhamHotspur.png',
    ARS : 'Fake_Arsenal.png',
    EVE : 'Fake_Everton.png',
    CRY : 'Fake_CrystalPalace.png',
    LIV : 'Fake_Liverpool.png',
    MCI : 'Fake_ManchesterCity.png',
    STK : 'Fake_StrokeCity.png',
     // Italy
     VER: 'Fake_StrokeCity.png',
     INT: 'Inter.png',
     ATA: 'Fake_StrokeCity.png',
     BOL: 'Fake_StrokeCity.png',
     BRE: 'Fake_StrokeCity.png',
     CAG: 'Fake_StrokeCity.png',
     FIO: 'Fake_StrokeCity.png',
     GEN: 'Fake_StrokeCity.png',
     JUV: 'Juventus.png',
     LAZ: 'Lazio.png',
     USL: 'Fake_StrokeCity.png',
     MIL: 'Milan.png',
     NAP: 'Fake_StrokeCity.png',
     PAR: 'Fake_StrokeCity.png',
     ROM: 'Roma.png',
     SAM: 'Fake_StrokeCity.png',
     SAS: 'Fake_StrokeCity.png',
     SPA: 'Fake_StrokeCity.png',
     TOR: 'Fake_StrokeCity.png',
     UDI: 'Fake_StrokeCity.png',
     // Spanish
     ALA: "Alaves.png",
     ATM: "Atm.png",
     BAR: "Barcelona.png",
     BIL: "Bilbao.png",
     CEV: "Cev.png",
     EIB: "Eibar.png",
     ESP: "Esp.png",
     GET: "Get.png",
     GRA: "Gra.png",
     LEG: "Leg.png",
     LEV: "Lev.png",
     OSA: "Osa.png",
     REB: "Reb.png",
     REM: "Rem.png",
     MAL: "Mal.png",
     REV: "Rev.png",
     SEV: "Sev.png",
     VAL: "Val.png",
     VIL: "Vil.png",
};

var jerseys = {
    BLU : 'Blue.png',
    WHT : 'White.png',
    RW :'Red_And_White.png',
    RED : 'Red.png',
    BLK : 'Black.png',
    YLW : 'Orange.png',
    BW : 'Black_And_White.png',
    GRN : 'Green.png'
}

let intros = [
{ videoCode : 'BLK-RW', video : 'BLK-RW_01.mp4'},
{ videoCode : 'BLK-RW', video : 'BLK-RW_02.mp4'},
{ videoCode : 'BLK-RW', video : 'BLK-RW_03.mp4'},
{ videoCode : 'BLK-RW', video : 'BLK-RW_04.mp4'},
{ videoCode : 'BLK-RW', video : 'BLK-RW_05.mp4'},
{ videoCode : 'BLK-RW', video : 'BLK-RW_06.mp4'},
{ videoCode : 'BLK-RW', video : 'BLK-RW_07.mp4'},
{ videoCode : 'BLK-RW', video : 'BLK-RW_08.mp4'},
{ videoCode : 'BLK-WHT' , video :'BLK-WHT_01.mp4'},
{ videoCode : 'BLK-WHT' , video :'BLK-WHT_02.mp4'},
{ videoCode : 'BLK-WHT' , video :'BLK-WHT_03.mp4'},
{ videoCode : 'BLK-WHT' , video :'BLK-WHT_04.mp4'},
{ videoCode : 'BLK-WHT' , video :'BLK-WHT_05.mp4'},
{ videoCode : 'BLK-WHT' , video :'BLK-WHT_06.mp4'},
{ videoCode : 'BLU-BLK' , video :'BLU-BLK_01.mp4'},
{ videoCode : 'BLU-BLK' , video :'BLU-BLK_02.mp4'},
{ videoCode : 'BLU-BLK' , video :'BLU-BLK_03.mp4'},
{ videoCode : 'BLU-BLK' , video :'BLU-BLK_04.mp4'},
{ videoCode : 'BLU-BLK' , video :'BLU-BLK_05.mp4'},
{ videoCode : 'BLU-BLK' , video :'BLU-BLK_06.mp4'},
{ videoCode : 'BLU-BLK' , video :'BLU-BLK_07.mp4'},
{ videoCode : 'BLU-BLK' , video :'BLU-BLK_08.mp4'},
{ videoCode : 'BLU-GRN' , video :'BLU-GRN_01.mp4'},
{ videoCode : 'BLU-GRN' , video :'BLU-GRN_02.mp4'},
{ videoCode : 'BLU-GRN' , video :'BLU-GRN_03.mp4'},
{ videoCode : 'BLU-GRN' , video :'BLU-GRN_04.mp4'},
{ videoCode : 'BLU-GRN' , video :'BLU-GRN_05.mp4'},
{ videoCode : 'BLU-GRN' , video :'BLU-GRN_06.mp4'},
{ videoCode : 'BLU-GRN' , video :'BLU-GRN_07.mp4'},
{ videoCode : 'BLU-RW', video : 'BLU-RW_01.mp4'},
{ videoCode : 'BLU-RW', video : 'BLU-RW_02.mp4'},
{ videoCode : 'BLU-RW', video : 'BLU-RW_03.mp4'},
{ videoCode : 'BLU-RW', video : 'BLU-RW_04.mp4'},
{ videoCode : 'BLU-RW', video : 'BLU-RW_05.mp4'},
{ videoCode : 'BLU-RW', video : 'BLU-RW_06.mp4'},
{ videoCode : 'BLU-RW', video : 'BLU-RW_07.mp4'},
{ videoCode : 'BLU-RW', video : 'BLU-RW_08.mp4'},
{ videoCode : 'BLU-WHT' , video :'BLU-WHT_01.mp4'},
{ videoCode : 'BLU-WHT' , video :'BLU-WHT_02.mp4'},
{ videoCode : 'BLU-WHT' , video :'BLU-WHT_03.mp4'},
{ videoCode : 'BLU-WHT' , video :'BLU-WHT_04.mp4'},
{ videoCode : 'BLU-WHT' , video :'BLU-WHT_05.mp4'},
{ videoCode : 'BLU-WHT' , video :'BLU-WHT_06.mp4'},
{ videoCode : 'BLU-WHT' , video :'BLU-WHT_07.mp4'},
{ videoCode : 'BLU-WHT' , video :'BLU-WHT_08.mp4'},
{ videoCode : 'GRN-BLK' , video :'GRN-BLK_01.mp4'},
{ videoCode : 'GRN-BLK' , video :'GRN-BLK_02.mp4'},
{ videoCode : 'GRN-BLK' , video :'GRN-BLK_03.mp4'},
{ videoCode : 'GRN-BLK' , video :'GRN-BLK_04.mp4'},
{ videoCode : 'GRN-BLK' , video :'GRN-BLK_05.mp4'},
{ videoCode : 'GRN-BLK' , video :'GRN-BLK_06.mp4'},
{ videoCode : 'GRN-BLK' , video :'GRN-BLK_07.mp4'},
{ videoCode : 'GRN-RW', video : 'GRN-RW_01.mp4'},
{ videoCode : 'GRN-RW', video : 'GRN-RW_02.mp4'},
{ videoCode : 'GRN-RW', video : 'GRN-RW_03.mp4'},
{ videoCode : 'GRN-RW', video : 'GRN-RW_04.mp4'},
{ videoCode : 'GRN-RW', video : 'GRN-RW_05.mp4'},
{ videoCode : 'GRN-RW', video : 'GRN-RW_06.mp4'},
{ videoCode : 'GRN-RW', video : 'GRN-RW_07.mp4'},
{ videoCode : 'GRN-WHT' , video :'GRN-WHT_01.mp4'},
{ videoCode : 'GRN-WHT' , video :'GRN-WHT_02.mp4'},
{ videoCode : 'GRN-WHT' , video :'GRN-WHT_03.mp4'},
{ videoCode : 'GRN-WHT' , video :'GRN-WHT_04.mp4'},
{ videoCode : 'GRN-WHT' , video :'GRN-WHT_05.mp4'},
{ videoCode : 'GRN-WHT' , video :'GRN-WHT_06.mp4'},
{ videoCode : 'RED-BLK' , video :'RED-BLK_01.mp4'},
{ videoCode : 'RED-BLK' , video :'RED-BLK_02.mp4'},
{ videoCode : 'RED-BLK' , video :'RED-BLK_03.mp4'},
{ videoCode : 'RED-BLK' , video :'RED-BLK_04.mp4'},
{ videoCode : 'RED-BLK' , video :'RED-BLK_05.mp4'},
{ videoCode : 'RED-BLK' , video :'RED-BLK_06.mp4'},
{ videoCode : 'RED-BLK' , video :'RED-BLK_07.mp4'},
{ videoCode : 'RED-BLU' , video :'RED-BLU_01.mp4'},
{ videoCode : 'RED-BLU' , video :'RED-BLU_02.mp4'},
{ videoCode : 'RED-BLU' , video :'RED-BLU_03.mp4'},
{ videoCode : 'RED-BLU' , video :'RED-BLU_04.mp4'},
{ videoCode : 'RED-BLU' , video :'RED-BLU_05.mp4'},
{ videoCode : 'RED-BLU' , video :'RED-BLU_06.mp4'},
{ videoCode : 'RED-GRN' , video :'RED-GRN_01.mp4'},
{ videoCode : 'RED-GRN' , video :'RED-GRN_02.mp4'},
{ videoCode : 'RED-GRN' , video :'RED-GRN_03.mp4'},
{ videoCode : 'RED-GRN' , video :'RED-GRN_04.mp4'},
{ videoCode : 'RED-GRN' , video :'RED-GRN_05.mp4'},
{ videoCode : 'RED-RW', video : 'RED-RW_01.mp4'},
{ videoCode : 'RED-RW', video : 'RED-RW_02.mp4'},
{ videoCode : 'RED-RW', video : 'RED-RW_03.mp4'},
{ videoCode : 'RED-RW', video : 'RED-RW_04.mp4'},
{ videoCode : 'RED-RW', video : 'RED-RW_05.mp4'},
{ videoCode : 'RED-RW', video : 'RED-RW_06.mp4'},
{ videoCode : 'RED-WHT' , video :'RED-WHT_01.mp4'},
{ videoCode : 'RED-WHT' , video :'RED-WHT_02.mp4'},
{ videoCode : 'RED-WHT' , video :'RED-WHT_03.mp4'},
{ videoCode : 'RED-WHT' , video :'RED-WHT_04.mp4'},
{ videoCode : 'RED-WHT' , video :'RED-WHT_05.mp4'},
{ videoCode : 'RED-WHT' , video :'RED-WHT_06.mp4'},
{ videoCode : 'RED-WHT' , video :'RED-WHT_07.mp4'},
{ videoCode : 'RED-WHT' , video :'RED-WHT_08.mp4'},
{ videoCode : 'RED-YLW' , video :'RED-YLW_01.mp4'},
{ videoCode : 'RED-YLW' , video :'RED-YLW_02.mp4'},
{ videoCode : 'RED-YLW' , video :'RED-YLW_03.mp4'},
{ videoCode : 'RED-YLW' , video :'RED-YLW_04.mp4'},
{ videoCode : 'RED-YLW' , video :'RED-YLW_05.mp4'},
{ videoCode : 'RED-YLW' , video :'RED-YLW_06.mp4'},
{ videoCode : 'RED-YLW' , video :'RED-YLW_07.mp4'},
{ videoCode : 'WHT-RW', video : 'WHT-RW_01.mp4'},
{ videoCode : 'WHT-RW', video : 'WHT-RW_02.mp4'},
{ videoCode : 'WHT-RW', video : 'WHT-RW_03.mp4'},
{ videoCode : 'WHT-RW', video : 'WHT-RW_04.mp4'},
{ videoCode : 'WHT-RW', video : 'WHT-RW_05.mp4'},
{ videoCode : 'WHT-RW', video : 'WHT-RW_06.mp4'},
{ videoCode : 'WHT-RW', video : 'WHT-RW_07.mp4'},
{ videoCode : 'WHT-RW', video : 'WHT-RW_08.mp4'},
{ videoCode : 'YLW-BLK' , video :'YLW-BLK_01.mp4'},
{ videoCode : 'YLW-BLK' , video :'YLW-BLK_02.mp4'},
{ videoCode : 'YLW-BLK' , video :'YLW-BLK_03.mp4'},
{ videoCode : 'YLW-BLK' , video :'YLW-BLK_04.mp4'},
{ videoCode : 'YLW-BLK' , video :'YLW-BLK_05.mp4'},
{ videoCode : 'YLW-BLK' , video :'YLW-BLK_06.mp4'},
{ videoCode : 'YLW-BLK' , video :'YLW-BLK_07.mp4'},
{ videoCode : 'YLW-BLU' , video :'YLW-BLU_01.mp4'},
{ videoCode : 'YLW-BLU' , video :'YLW-BLU_02.mp4'},
{ videoCode : 'YLW-BLU' , video :'YLW-BLU_03.mp4'},
{ videoCode : 'YLW-BLU' , video :'YLW-BLU_04.mp4'},
{ videoCode : 'YLW-BLU' , video :'YLW-BLU_05.mp4'},
{ videoCode : 'YLW-BLU' , video :'YLW-BLU_06.mp4'},
{ videoCode : 'YLW-BLU' , video :'YLW-BLU_07.mp4'},
{ videoCode : 'YLW-BLU' , video :'YLW-BLU_08.mp4'},
{ videoCode : 'YLW-GRN' , video :'YLW-GRN_01.mp4'},
{ videoCode : 'YLW-GRN' , video :'YLW-GRN_02.mp4'},
{ videoCode : 'YLW-GRN' , video :'YLW-GRN_03.mp4'},
{ videoCode : 'YLW-GRN' , video :'YLW-GRN_04.mp4'},
{ videoCode : 'YLW-RW', video : 'YLW-RW_01.mp4'},
{ videoCode : 'YLW-RW', video : 'YLW-RW_02.mp4'},
{ videoCode : 'YLW-RW', video : 'YLW-RW_03.mp4'},
{ videoCode : 'YLW-RW', video : 'YLW-RW_04.mp4'},
{ videoCode : 'YLW-RW', video : 'YLW-RW_05.mp4'},
{ videoCode : 'YLW-RW', video : 'YLW-RW_06.mp4'},
{ videoCode : 'YLW-RW', video : 'YLW-RW_07.mp4'},
{ videoCode : 'YLW-WHT' , video :'YLW-WHT_01.mp4'},
{ videoCode : 'YLW-WHT' , video :'YLW-WHT_02.mp4'},
{ videoCode : 'YLW-WHT' , video :'YLW-WHT_03.mp4'},
{ videoCode : 'YLW-WHT' , video :'YLW-WHT_04.mp4'},
{ videoCode : 'YLW-WHT' , video :'YLW-WHT_05.mp4'},
{ videoCode : 'YLW-WHT' , video :'YLW-WHT_06.mp4'},
{ videoCode : 'YLW-WHT' , video :'YLW-WHT_07.mp4'},
];

window['videoDuration'] = {
};
let videoElements = {
    intro1 : 'matchVideoIntro1',
    intro2 : 'matchVideoIntro2',
    intro3 : 'matchVideoIntro3',
    video1 : 'matchVideo1',
    video2 : 'matchVideo2',
    video3 : 'matchVideo3',
    video4 : 'matchVideo4',
    video5 : 'matchVideo5',
    video6 : 'matchVideo6'
}
module.exports = {
  playVideo: function(data){
    console.log('Play Video');
   
    matchData = data['LeagueMatches'][findMatchToPlay(data)];

    if(parseInt(matchData.MatchTimer) < 100){
          finishVideo(matchData, data);  
          return false;
       } 

    var selectedIntros = findIntro(matchData.Kit_Home, matchData.Kit_Away);
    videos = {
        intro1 : selectedIntros[0],
        intro2 : selectedIntros[1],
        intro3 : selectedIntros[2],
        video1 : matchData.video1.split('_')[0],
        video2 : matchData.video2.split('_')[0],
        video3 : matchData.video3.split('_')[0],
        video4 : matchData.video4.split('_')[0],
        video5 : matchData.video5.split('_')[0],
        video6 : matchData.video6.split('_')[0]
    } 
    

    window['videoDuration'] = {
        intro1 : 0,
        intro2 : 0,
        intro3 : 0,
        video1 : 0,
        video2 : 0,
        video3 : 0,
        video4 : 0,
        video5 : 0,
        video6 : 0
    };

    if(loadVideos(videos) == false){
        setTimeout(function () {
            playVideos(window['videoDuration'], matchData, data);
        }, 3000);

    } 

    $('#home-abbreviation').text(matchData.CodeHome);
    $('#away-abbreviation').text(matchData.CodeAway);
    $('#homeGoals').text('0');
    $('#awayGoals').text('0');
    $('#videoMinute').text('');
  }
};

function playVideos(durations, match, data){
    $('#results').hide();
    $('#videos').show();

    intro1timer = setTimeout(function () {
        //console.log('start intro 1')
        startSingleVideo('intro1');
        updateLivescore(data, 0);
        clearTimeout(intro1timer)
        $('.livescore-small ').addClass('open')
    }, 0);

    intro2timer = setTimeout(function () {
        startSingleVideo('intro2');
        //console.log('start intro 2')
        clearTimeout(intro2timer)
    }, durations.intro1);

    intro3timer = setTimeout(function () {
        startSingleVideo('intro3');
        //console.log('start intro 3')
        updateLivescore(data, 0)
        clearTimeout(intro3timer)
    }, durations.intro1 + durations.intro2);
     
    video1timer = setTimeout(function () {
        startSingleVideo('video1');
        //console.log('start video 1')
        updateLive(match, 1)
        clearTimeout(video1timer)
    }, durations.intro1 + durations.intro2 + durations.intro3);

    video2timer = setTimeout(function () {
        startSingleVideo('video2');
       // console.log('start video 2')
        updateLive(match, 2)
        updateLivescore(data, 2)
        clearTimeout(video2timer)
    }, durations.intro1 + durations.intro2 + durations.intro3 + durations.video1);

    video3timer = setTimeout(function () {
        startSingleVideo('video3');
       // console.log('start video 3')
        updateLive(match, 3)
        updateLivescore(data, 3)
        clearTimeout(video3timer)
    }, durations.intro1 + durations.intro2 + durations.intro3 + durations.video1 + durations.video2);

    video4timer = setTimeout(function () {
        startSingleVideo('video4');
        //console.log('start video 4')
        updateLive(match, 4)
        updateLivescore(data, 4)
        clearTimeout(video4timer)
    }, durations.intro1 + durations.intro2 + durations.intro3 + durations.video1 + durations.video2 + durations.video3);
    
    video5timer = setTimeout(function () {
        
        startSingleVideo('video5');
        //console.log('start video 5')
        updateLive(match, 5)
        updateLivescore(data, 5)
        clearTimeout(video5timer)
    }, durations.intro1 + durations.intro2 + durations.intro3 + durations.video1 + durations.video2 + durations.video3 + durations.video4);
    
    video6timer = setTimeout(function () {
        startSingleVideo('video6');
       // console.log('start video 6')
        updateLive(match, 6)
        updateLivescore(data, 6);
        clearTimeout(video6timer)
    }, durations.intro1 + durations.intro2 + durations.intro3 + durations.video1 + durations.video2 + durations.video3 + durations.video4 + durations.video5);
     
    video7timer = setTimeout(function () {
        finishVideo(match, data);
        $('#matchVideo6')[0].pause();
        clearTimeout(video7timer)

    }, durations.intro1 + durations.intro2 + durations.intro3 + durations.video1 + durations.video2 + durations.video3 + durations.video4 + durations.video5 + durations.video6);

     
}


function updateLivescore(data, video){
    var livescore = [];
    $.each( data['LeagueMatches'], function( key, value ) {
        var homeGoals = 0;
        var awayGoals = 0;
       
        video1Result = value.video1.split('_')[1];
        video2Result = value.video2.split('_')[1];
        video3Result = value.video3.split('_')[1];
        video4Result = value.video4.split('_')[1];
        video5Result = value.video5.split('_')[1];
        video6Result = value.video6.split('_')[1];

        homeGoals = parseInt(video1Result.charAt(0)) + parseInt(video2Result.charAt(0)) + parseInt(video3Result.charAt(0)) + parseInt(video4Result.charAt(0)) + parseInt(video5Result.charAt(0)) + parseInt(video6Result.charAt(0));
        awayGoals = parseInt(video1Result.charAt(1)) + parseInt(video2Result.charAt(1)) + parseInt(video3Result.charAt(1)) + parseInt(video4Result.charAt(1)) + parseInt(video5Result.charAt(1)) + parseInt(video6Result.charAt(1));

        var gameFlow = [
            parseInt(video1Result.charAt(0)) +':'+parseInt(video1Result.charAt(1)),
            (parseInt(video1Result.charAt(0)) +  parseInt(video2Result.charAt(0))) +':'+ (parseInt(video1Result.charAt(1)) + parseInt(video2Result.charAt(1))),
            (parseInt(video1Result.charAt(0)) +  parseInt(video2Result.charAt(0)) + parseInt(video3Result.charAt(0)))  +':'+ (parseInt(video1Result.charAt(1)) + parseInt(video2Result.charAt(1)) + parseInt(video3Result.charAt(1))),
            (parseInt(video1Result.charAt(0)) + parseInt(video2Result.charAt(0)) + parseInt(video3Result.charAt(0)) + parseInt(video4Result.charAt(0))) +':'+ (parseInt(video1Result.charAt(1)) + parseInt(video2Result.charAt(1)) + parseInt(video3Result.charAt(1)) + parseInt(video4Result.charAt(1))),
            (parseInt(video1Result.charAt(0)) + parseInt(video2Result.charAt(0)) + parseInt(video3Result.charAt(0)) + parseInt(video4Result.charAt(0)) + parseInt(video5Result.charAt(0))) +':'+ (parseInt(video1Result.charAt(1)) + parseInt(video2Result.charAt(1)) + parseInt(video3Result.charAt(1)) + parseInt(video4Result.charAt(1)) + parseInt(video5Result.charAt(1))),
            (parseInt(video1Result.charAt(0)) + parseInt(video2Result.charAt(0)) + parseInt(video3Result.charAt(0)) + parseInt(video4Result.charAt(0)) + parseInt(video5Result.charAt(0)) + parseInt(video6Result.charAt(0))) +':'+ (parseInt(video1Result.charAt(1)) + parseInt(video2Result.charAt(1)) + parseInt(video3Result.charAt(1)) + parseInt(video4Result.charAt(1)) + parseInt(video5Result.charAt(1)) + parseInt(video6Result.charAt(1))),
        ];
     
         livescore[key] = {
            gameId : value.ID,
            TeamNameHome : value.TeamNameHome,
            TeamNameAway : value.TeamNameAway,
            Kit_Away : value.Kit_Away,
            Kit_Home : value.Kit_Home,
            LogoAway : value.LogoAway,
            LogoHome : value.LogoHome,
            homeGoals : homeGoals,
            awayGoals : awayGoals,
            CodeHome : value.CodeHome,
            CodeAway : value.CodeAway,
            gameFlow : gameFlow,
            halftime : gameFlow[2]
        };
        
    });

   drawLivescore(livescore, video);

}

function drawLivescore(data, video){
    $('.livescore-body').empty();

     $.each( data, function( key, value ) {
         var halfTime = '-:-';
         var fullTime = '0:0';
         if(video > 1) {
             fullTime = value.gameFlow[video-2]
         }
         if(video > 3) {
             halfTime = value.gameFlow[2]
         }
         $('.livescore-body').append(liveScoreHtml(key+1, value.Kit_Home, value.Kit_Away, value.CodeHome, value.CodeAway, halfTime, fullTime));
       
    })
}

function liveScoreHtml(n, kitHome, kitAway, homeTeam, awayTeam, halfTime, fullTime){
/*
    var html = '<tr>'+
            '<td class="ls-number">'+n+'</td>'+
            '<td class="ls-teams">'+
                '<div class="home-ls-team" style="background-image:url(img/jerseys/'+jerseys[kitHome]+')">'+homeTeam+'</div>'+
                '<div class="away-ls-team" style="background-image:url(img/jerseys/'+jerseys[kitAway]+')">'+awayTeam+'</div>'+
            '</td>'+
            '<td class="ls-result"><div class="ls-fulltime">'+fullTime+'</div></td>'+
            '<td class="ls-result"><div class="ls-halftime">'+halfTime+'</div></td>'+
           '</tr>';
           */

           var html = '<div class="livescore-box">' +
                                        '<div class="livescore-n">'+n+'</div>' +
                                        '<div class="livescore-teams">' +
                                            '<div class="livescore-team1" style="background-image:url(img/jerseys/'+jerseys[kitHome]+')">'+homeTeam+'</div>' +
                                            '<div class="livescore-team2" style="background-image:url(img/jerseys/'+jerseys[kitAway]+')">'+awayTeam+'</div>' +
                                        '</div>' +
                                        '<div class="livescore-result">' +
                                            '<div class="livescore-ft">'+fullTime+'</div>' +
                                            '<div class="livescore-ht">'+halfTime+'</div>' +
                                        '</div>' +
                                    '</div>' ;
    return html;       
}

function startSingleVideo(elem){
    $('.video-js').css({'display': 'none'});

    let intro1 = $('#matchVideoIntro1')[0];
    let intro2 = $('#matchVideoIntro2')[0];
    let intro3 = $('#matchVideoIntro3')[0];
    let video1 = $('#matchVideo1')[0];
    let video2 =  $('#matchVideo2')[0];
    let video3 = $('#matchVideo3')[0];
    let video4 = $('#matchVideo4')[0];
    let video5 = $('#matchVideo5')[0];
    let video6 = $('#matchVideo6')[0];

    switch (elem) {
        case 'intro1':
            $('#matchVideoIntro1').show();
            $('#matchVideoIntro1')[0].play();
            break;
        case 'intro2':
            $('#matchVideoIntro2').show();
            $('#matchVideoIntro2')[0].play();
            $('#matchVideoIntro1')[0].pause();
            break;
        case 'intro3':
            $('#matchVideoIntro3').show();
            $('#matchVideoIntro3')[0].play();
            $('#matchVideoIntro2')[0].pause();
            break;
        case 'video1':
             $('#matchVideo1').show();
            $('#matchVideo1')[0].play();
            $('#matchVideoIntro3')[0].pause();
            break;
        case 'video2':
             $('#matchVideo2').show();
            $('#matchVideo2')[0].play();
            $('#matchVideo1')[0].pause();
            break;
        case 'video3':
             $('#matchVideo3').show();
            $('#matchVideo3')[0].play();
             $('#matchVideo2')[0].pause();
            break;
        case 'video4':
             $('#matchVideo4').show();
            $('#matchVideo4')[0].play();
            $('#matchVideo3')[0].pause();
            break;
        case 'video5':
             $('#matchVideo5').show();
            $('#matchVideo5')[0].play();
            $('#matchVideo4')[0].pause();
            break;
        case 'video6':
             $('#matchVideo6').show();
            $('#matchVideo6')[0].play();
            $('#matchVideo5')[0].pause();
            break;

    }
}

function loadVideos(videos){
    videoUrl = 'https://s3-eu-west-1.amazonaws.com/elbetvideo/vFootballLeague/';
    introUrl = 'https://s3-eu-west-1.amazonaws.com/elbetvideo/vFootballLeague/Intro/';

    let intro1 = $('#matchVideoIntro1')[0];
    let intro2 = $('#matchVideoIntro2')[0];
    let intro3 = $('#matchVideoIntro3')[0];
    let video1 = $('#matchVideo1')[0];
    let video2 =  $('#matchVideo2')[0];
    let video3 = $('#matchVideo3')[0];
    let video4 = $('#matchVideo4')[0];
    let video5 = $('#matchVideo5')[0];
    let video6 = $('#matchVideo6')[0];

    if(window['videoDuration'].intro1 == 0) {
        intro1.src = introUrl+videos.intro1;
        intro1.load();
        intro1.pause();
        intro1.onloadedmetadata = function() {
            window['videoDuration'].intro1 = Math.floor(intro1.duration) * 1000;
        };
    }
    if(window['videoDuration'].intro2 == 0) {
        
        intro2.src = introUrl+videos.intro2;
        intro2.load();
        intro2.pause();
        intro2.onloadedmetadata = function() {
            window['videoDuration'].intro2 = Math.floor(intro2.duration) * 1000;
        };
    }
    if(window['videoDuration'].intro3 == 0) {
        
        intro3.src = introUrl+videos.intro3;
        intro3.load();
        intro3.pause();
        intro3.onloadedmetadata = function() {
            window['videoDuration'].intro3 = Math.floor(intro3.duration) * 1000;
        };
    }
    if(window['videoDuration'].video1 == 0) {
        video1.src = videoUrl+videos.video1+'.mp4';
        video1.load();
        video1.pause();
        video1.onloadedmetadata = function() {
            window['videoDuration'].video1 = Math.floor(video1.duration) * 1000;
        };
    }
    if(window['videoDuration'].video2 == 0) {
        
        video2.src = videoUrl+videos.video2+'.mp4';
        video2.load();
        video2.pause();
        video2.onloadedmetadata = function() {
            window['videoDuration'].video2 = Math.floor(video2.duration) * 1000;
        };
    }
    if(window['videoDuration'].video3 == 0) {
        
        video3.src = videoUrl+videos.video3+'.mp4';
        video3.load();
        video3.pause();
        video3.onloadedmetadata = function() {
            window['videoDuration'].video3 = Math.floor(video3.duration) * 1000;
        };
    }

    if(window['videoDuration'].video4 == 0) {
        
        video4.src = videoUrl+videos.video4+'.mp4';
        video4.load();
        video4.pause();
        video4.onloadedmetadata = function() {
            window['videoDuration'].video4 = Math.floor(video4.duration) * 1000;
        };
    }
        if(window['videoDuration'].video5 == 0) {
        
        video5.src = videoUrl+videos.video5+'.mp4';
        video5.load();
        video5.pause();
        video5.onloadedmetadata = function() {
            window['videoDuration'].video5 = Math.floor(video5.duration) * 1000;
        };
    }
    if(window['videoDuration'].video6 == 0) {
        
        video6.src = videoUrl+videos.video6+'.mp4';
        video6.load();
        video6.onloadedmetadata = function() {
            video6.pause();
            window['videoDuration'].video6 = Math.floor(video6.duration) * 1000;
        };
    }

    if ( intro1.readyState === 4 && intro2.readyState === 4 && intro3.readyState === 4 && video1.readyState === 4 && video2.readyState === 4 && video3.readyState === 4 && video4.readyState === 4 && video5.readyState === 4 && video6.readyState === 4) {
           return window['videoDuration'];
    } else {
        //console.log('videos not loaded')
        setTimeout(function(){
            loadVideos(videos)
        }, 3000);
        return false;
    }
        
}

function updateLive(match, video){
    $('#videoScore').text(getMatchResult(match, video-1));
    $('#videoMinute').text(getMatchTime(match, video) + "'");
}

function getMatchTime(match, video){
    let minutes = {
            1: [1, 15],
            2: [16, 30],
            3: [31, 45],
            4: [46, 60],
            5: [61, 75],
            6: [76, 90]
        };

    return getRandomNumber(minutes[video][0], minutes[video][1]);      
}

function getMatchResult(match, video = 6){
    video1Result = match.video1.split('_')[1];
    video2Result = match.video2.split('_')[1];
    video3Result = match.video3.split('_')[1];
    video4Result = match.video4.split('_')[1];
    video5Result = match.video5.split('_')[1];
    video6Result = match.video6.split('_')[1];

    homeGoals = parseInt(video1Result.charAt(0)) + parseInt(video2Result.charAt(0)) + parseInt(video3Result.charAt(0)) + parseInt(video4Result.charAt(0)) + parseInt(video5Result.charAt(0)) + parseInt(video6Result.charAt(0));
    awayGoals = parseInt(video1Result.charAt(1)) + parseInt(video2Result.charAt(1)) + parseInt(video3Result.charAt(1)) + parseInt(video4Result.charAt(1)) + parseInt(video5Result.charAt(1)) + parseInt(video6Result.charAt(1));

    var gameFlow = [
        parseInt(video1Result.charAt(0)) +':'+parseInt(video1Result.charAt(1)),
        (parseInt(video1Result.charAt(0)) +  parseInt(video2Result.charAt(0))) +':'+ (parseInt(video1Result.charAt(1)) + parseInt(video2Result.charAt(1))),
        (parseInt(video1Result.charAt(0)) +  parseInt(video2Result.charAt(0)) + parseInt(video3Result.charAt(0)))  +':'+ (parseInt(video1Result.charAt(1)) + parseInt(video2Result.charAt(1)) + parseInt(video3Result.charAt(1))),
        (parseInt(video1Result.charAt(0)) + parseInt(video2Result.charAt(0)) + parseInt(video3Result.charAt(0)) + parseInt(video4Result.charAt(0))) +':'+ (parseInt(video1Result.charAt(1)) + parseInt(video2Result.charAt(1)) + parseInt(video3Result.charAt(1)) + parseInt(video4Result.charAt(1))),
        (parseInt(video1Result.charAt(0)) + parseInt(video2Result.charAt(0)) + parseInt(video3Result.charAt(0)) + parseInt(video4Result.charAt(0)) + parseInt(video5Result.charAt(0))) +':'+ (parseInt(video1Result.charAt(1)) + parseInt(video2Result.charAt(1)) + parseInt(video3Result.charAt(1)) + parseInt(video4Result.charAt(1)) + parseInt(video5Result.charAt(1))),
        (parseInt(video1Result.charAt(0)) + parseInt(video2Result.charAt(0)) + parseInt(video3Result.charAt(0)) + parseInt(video4Result.charAt(0)) + parseInt(video5Result.charAt(0)) + parseInt(video6Result.charAt(0))) +':'+ (parseInt(video1Result.charAt(1)) + parseInt(video2Result.charAt(1)) + parseInt(video3Result.charAt(1)) + parseInt(video4Result.charAt(1)) + parseInt(video5Result.charAt(1)) + parseInt(video6Result.charAt(1))),
    ];

    return gameFlow[video-1];
}

function finishVideo(match, data){
    showResult(match);
    ticket.updateTicket(data);
    $('.livescore-small ').removeClass('open')
}

function findIntro(home, away) {
    var selectedIntros = [];
    introKey1 = away+"-"+home;
    introKey2 = home+"-"+away;
    $.each(intros, function( key, value ) {
        if(value.videoCode == introKey1 || value.videoCode == introKey2){
            selectedIntros.push(value.video)
        }
    });
    var randVideo = getRandom(selectedIntros, 3);
    return randVideo;
  }

function showResult(match){
    var result = getMatchResult(match);
    var halfTime = getMatchResult(match, 3);
    var homeGoals = result.split(':')[0];
    var awayGoals = result.split(':')[1];
    var homeHalftimeGoals = halfTime.split('-')[0];
    var awayHalftimeGoals = halfTime.split('-')[1];
    var matchWinner = translation['draw'].toUpperCase();
    var matchWinnerSymbol = 'X';
    var halfTimeSymbol = 'X';

    if(parseInt(homeGoals) > parseInt(awayGoals)){
        matchWinner = translation['home'].toUpperCase();
        matchWinnerSymbol = '1';
    }
    if(parseInt(homeGoals) < parseInt(awayGoals)){
        matchWinner = translation['away'].toUpperCase();
        matchWinnerSymbol = '2';
    } 

    if(parseInt(homeHalftimeGoals) > parseInt(awayHalftimeGoals)){
        halfTimeSymbol = '1';
    }
    if(parseInt(homeHalftimeGoals) < parseInt(awayHalftimeGoals)){
        halfTimeSymbol = '2';
    } 

    $('.video-js').css({'display': 'none'});
    $('#videos').hide();
    $('#results').show();

    $('#homeGoals').text(homeGoals);
    $('#awayGoals').text(awayGoals);
    $('#homeTeam').text(match.TeamNameHome);
    $('#awayTeam').text(match.TeamNameAway);

    $('#home-flag').css({'background-image' : 'url(img/amblems/left/logos/'+amblems[match.CodeHome]+')'})
    $('#away-flag').css({'background-image' : 'url(img/amblems/right/logos/'+amblems[match.CodeAway]+')'})

    $('#matchWinner').text(matchWinner);
    $('#matchTotalGoals').text(parseInt(homeGoals) + parseInt(awayGoals));
    $('#matchCorrectScore').text(homeGoals+':'+awayGoals);
    $('#matchHtFt').text(halfTimeSymbol+'-'+matchWinnerSymbol);
    
    $('#matchResult').html(result + '<span class="ident-left">('+halfTime+')</span>');

}

function getRandom(arr, n) {
    var result = new Array(n),
        len = arr.length,
        taken = new Array(len);
    while (n--) {
        var x = Math.floor(Math.random() * len);
        result[n] = arr[x in taken ? taken[x] : x];
        taken[x] = --len in taken ? taken[len] : len;
    }
    return result;
}

function findMatchToPlay(data){
    var toPlay = 0;
     $.each( data['LeagueMatches'], function( key, value ) {
         if(value.Live == 1 || value.Live == '1'){
            toPlay = key; 
         }
     });

     return toPlay;
}

function hasAllProperties(obj, props) {
    for (var i = 0; i < props.length; i++) {
        if (!obj.hasOwnProperty(props[i]))
            return false;
    }
    return true;
}

 function getRandomNumber(min, max){
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }



//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/js/modules/video/video.js
// module id = 2024
// module chunks = 4